<ng-container *ngIf="loading">
  <div class="loading-bar">
    <tm1-progress-ring value="" min="0" max="1" size="regular"></tm1-progress-ring>
  </div>
</ng-container>

<div class="performance-page">
  <div class="page-header">
    <tm1-typography type="title-page">Performance</tm1-typography>
  </div>

  <div *ngIf="loadError" class="performance-error">
    <tm1-banner appearance="error">{{ loadError }}</tm1-banner>
  </div>

  <div class="filter-card">
    <div class="filter-field">
      <label class="filter-label">Venue</label>
      <select class="form-control" [(ngModel)]="selectedVenue" (change)="onVenueChange()">
        <option value="">Please select a venue</option>
        <option *ngFor="let venue of venuelist; trackBy: trackVenue" [value]="venue.key">
          {{ venue.value.name }}
        </option>
      </select>
    </div>

    <div class="filter-field">
      <label class="filter-label">Week</label>
      <div class="week-stepper">
        <button type="button" class="week-btn" (click)="prevWeek()" aria-label="Previous week">
          <svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4l-6 6 6 6"/></svg>
        </button>
        <span class="week-label">{{ weekLabel }}</span>
        <button type="button" class="week-btn" (click)="nextWeek()" aria-label="Next week">
          <svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 4l6 6-6 6"/></svg>
        </button>
      </div>
    </div>

    <button type="button" class="btn btn-modern btn-modern--ghost" (click)="goToday()">Today</button>

    <div class="filter-spacer"></div>

    <span class="summary-count">{{ filteredPerformances.length }} performances</span>

    <button type="button"
            class="btn btn-modern btn-modern--primary"
            (click)="openAdd()"
            [disabled]="!selectedVenue || isAdding">
      <svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M10 4v12"/>
        <path d="M4 10h12"/>
      </svg>
      <span>Add performance</span>
    </button>
  </div>

  <p class="stage-legend">
    Stages: EL Event listing loaded · TC Test config · TM1 Entry configured · TST Testing
  </p>

  <app-add-performance
    *ngIf="isAdding"
    [venueID]="selectedVenue"
    [venueTimezone]="venueTimezone"
    (saved)="onAddSaved()"
    (cancelled)="onAddCancelled()">
  </app-add-performance>

  <ng-container *ngIf="selectedVenue && !loading && !loadError">
    <tm1-empty-state
      *ngIf="!filteredPerformances.length"
      variant="no-result"
      title="No performances this week"
      subtitle="Try another week, or click 'Add performance' to create one.">
    </tm1-empty-state>

    <div class="card-container" *ngIf="filteredPerformances.length">
      <div class="perf-card">
        <div class="perf-card-head">
          <div>
            <div class="perf-card-eyebrow">PERFORMANCES</div>
            <div class="perf-card-title">{{ filteredPerformances.length }} this week</div>
          </div>
          <button type="button"
                  class="btn-download"
                  [disabled]="!filteredPerformances.length"
                  appTooltip="Download the visible performances as an Excel file"
                  aria-label="Download performances"
                  (click)="downloadPerformances()">
            <svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10 3v10"/>
              <path d="M5 10l5 5 5-5"/>
              <path d="M3 17h14"/>
            </svg>
          </button>
        </div>

        <div class="perf-table">
          <div class="perf-row perf-row--header"
               [class.perf-row--with-actions]="hasActions"
               [class.perf-row--with-actions-tm]="isTicketmaster">
            <div class="col-date">DATE</div>
            <div class="col-perf">PERFORMANCE</div>
            <div class="col-status">STATUS</div>
            <div class="col-stage" *ngFor="let s of stageCodes; trackBy: trackStageCode">{{ s }}</div>
            <div class="col-updated">UPDATED</div>
            <div class="col-actions" *ngIf="hasActions">ACTIONS</div>
          </div>

          <div class="perf-row perf-row--clickable"
               [class.perf-row--with-actions]="hasActions"
               [class.perf-row--with-actions-tm]="isTicketmaster"
               [ngClass]="'perf-row--status-' + statusPill(p).variant"
               *ngFor="let p of filteredPerformances; trackBy: trackPerformance"
               (click)="openDetail(p)">
            <div class="col-date">{{ formatDate(p.item) }}</div>
            <div class="col-perf">
              <div class="perf-title">{{ p.description || '—' }}</div>
              <div class="perf-meta">
                <span class="perf-meta-time">{{ formatTime(p.item) }}</span>
                <span class="perf-chip perf-chip--{{ relativeWhen(p).variant }}" *ngIf="relativeWhen(p).label">
                  {{ relativeWhen(p).label }}
                </span>
                <span class="perf-chip perf-chip--accent" *ngIf="customCount(p) > 0"
                      [appTooltip]="'Custom events added by client'">
                  <svg viewBox="0 0 16 16" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M8 3v10"/>
                    <path d="M3 8h10"/>
                  </svg>
                  {{ customCount(p) }} custom
                </span>
              </div>
            </div>
            <div class="col-status">
              <span class="pill pill--{{ statusPill(p).variant }}">{{ statusPill(p).label }}</span>
            </div>
            <div class="col-stage" *ngFor="let s of stageCodes; let i = index; trackBy: trackStageCode">
              <span class="stage-dot stage-dot--{{ stageState(p, i) }}"
                    [attr.title]="s + ': ' + stageState(p, i)">
                <ng-container [ngSwitch]="stageState(p, i)">
                  <svg *ngSwitchCase="'done'" viewBox="0 0 16 16" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8l3 3 7-7"/></svg>
                  <span *ngSwitchCase="'progress'" class="stage-dot-pulse"></span>
                </ng-container>
              </span>
            </div>
            <div class="col-updated">{{ formatLastUpdated(p) }}</div>
            <div class="col-actions" *ngIf="hasActions">
              <button type="button"
                      class="btn-row-icon"
                      *ngIf="isGlobalAdmin"
                      appTooltip="Configure alerts for this performance"
                      aria-label="Alerts"
                      (click)="openAlerts(p, $event)">
                <svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M10 2a5 5 0 0 0-5 5v3l-2 3h14l-2-3V7a5 5 0 0 0-5-5z"/>
                  <path d="M8 16a2 2 0 0 0 4 0"/>
                </svg>
              </button>
              <button type="button"
                      class="btn-row-icon"
                      *ngIf="isTicketmaster"
                      appTooltip="Edit performance description"
                      aria-label="Edit"
                      (click)="openEdit(p, $event)">
                <svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M14.5 3.5l2 2-9 9H5.5v-2l9-9z"/>
                  <path d="M12.5 5.5l2 2"/>
                </svg>
              </button>
              <button type="button"
                      class="btn-row-icon btn-row-icon--danger"
                      *ngIf="isTicketmaster"
                      appTooltip="Delete performance"
                      aria-label="Delete"
                      (click)="openDelete(p, $event)">
                <svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M4 6h12"/>
                  <path d="M8 6V4h4v2"/>
                  <path d="M6 6l1 10h6l1-10"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="stage-key" *ngIf="filteredPerformances.length">
      <span><span class="stage-dot stage-dot--done"><svg viewBox="0 0 16 16" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8l3 3 7-7"/></svg></span> complete</span>
      <span><span class="stage-dot stage-dot--progress"><span class="stage-dot-pulse"></span></span> in progress</span>
      <span><span class="stage-dot stage-dot--none"></span> not started</span>
    </div>
  </ng-container>
</div>

<app-alerts *ngIf="alertsTarget && isGlobalAdmin"
            [venueID]="selectedVenue"
            [venueTimezone]="venueTimezone"
            [performance]="alertsTarget"
            [otherPerformances]="otherPerformances"
            (closed)="closeAlerts()">
</app-alerts>

<app-edit-performance *ngIf="editTarget && isTicketmaster"
                      [venueID]="selectedVenue"
                      [venueTimezone]="venueTimezone"
                      [performance]="editTarget"
                      (saved)="onEditSaved()"
                      (cancelled)="closeEdit()">
</app-edit-performance>

<div class="delete-modal-backdrop" *ngIf="deleteTarget && isTicketmaster" (click)="$event.target === $event.currentTarget && cancelDelete()">
  <div class="delete-modal" role="dialog" aria-modal="true" aria-labelledby="deletePerformanceTitle">
    <div class="delete-modal-header">
      <div>
        <h2 id="deletePerformanceTitle" class="delete-modal-title">Delete performance?</h2>
        <div class="delete-modal-sub">This cannot be undone.</div>
      </div>
      <button type="button" class="delete-modal-close" aria-label="Close" [disabled]="deleteSaving" (click)="cancelDelete()">×</button>
    </div>
    <div class="delete-modal-content">
      <tm1-banner *ngIf="deleteError" appearance="error" class="delete-modal-banner">{{ deleteError }}</tm1-banner>
      <p class="delete-modal-line">
        <strong>{{ deleteTarget.description || '—' }}</strong><br />
        <span class="delete-modal-meta">{{ formatDate(deleteTarget.item) }} · {{ formatTime(deleteTarget.item) }}</span>
      </p>
      <p class="delete-modal-warn">
        Removes the performance record and unlinks it from the dashboard. Existing scan-test data tied to this slot will become orphaned.
      </p>
      <div class="delete-modal-actions">
        <button type="button" class="btn-modal btn-modal--ghost" [disabled]="deleteSaving" (click)="cancelDelete()">Cancel</button>
        <button type="button" class="btn-modal btn-modal--danger" [disabled]="deleteSaving" (click)="confirmDelete()">
          {{ deleteSaving ? 'Deleting…' : 'Delete performance' }}
        </button>
      </div>
    </div>
  </div>
</div>
